import { WSIcons } from "../../commonFunctions/iIcons";

export const getMenu = (userType: any) => {
  const adminMenu = [
    { id: 1, label: "Dashboard", icon: WSIcons.Home, path: "/dashboard" },
    
    { id: 3, label: "Region Management", icon: WSIcons.Building, path: "/manage" },
    { id: 4, label: "Loan Requests", icon: WSIcons.Document, path: "/loan/requests/list" },
    { id: 5, label: "Repayments", icon: WSIcons.Loan, path: "/loan/repayment/requests/list/filter" },
    // { id: 7, label: "Unauthorized Logs", icon: WSIcons.Hidden, path: "/unauthorizedLogs/list" },notifications
    
    { id: 8, label: "Finalized Loans", icon: WSIcons.Completed, path: "/loan/requests/final/list" },
    { id: 9, label: "Reports", icon: WSIcons.Report, path: "/reports" },
    { id: 2, label: "All Users", icon: WSIcons.LockIcon, path: "/users/list" },
    // { id: 7, label: "Notifications", icon: WSIcons.NotificationsNone, path: "/notifications" },
    { id: 7, label: "Upload Loans", icon: WSIcons.Upload, path: "/upload/loans" },
    { id: 10, label: "About", icon: WSIcons.InfoIcon, path: "/aboutus" },
  ];

  const districtMenu = [
    { id: 1, label: "Dashboard", icon: WSIcons.Home, path: "/dashboard" },
    { id: 7, label: "Loan Requests", icon: WSIcons.Document, path: '/loan/requests/list' },
    { id: 9, label: "Repayments", icon: WSIcons.Loan, path: "/loan/repayment/requests/list/filter" },
    
    { id: 10, label: "Finalized Loans", icon: WSIcons.Completed, path: "/loan/requests/final/list" },
    { id: 4, label: "Manage Blocks", icon: WSIcons.Building, path: "/manage/blocks" },
    { id: 3, label: "Reports", icon: WSIcons.Report, path: "/reports" },
    { id: 2, label: "All Users", icon: WSIcons.LockIcon, path: "/users/list" },
    // { id: 8, label: "Notifications", icon: WSIcons.NotificationsNone, path: "/notifications" },
    // { id: 8, label: "Upload Loans", icon: WSIcons.Upload, path: "/upload/loans" },
    { id: 11, label: "About", icon: WSIcons.InfoIcon, path: "/aboutus" },
  ];

  const blockMenu = [
    { id: 1, label: "Dashboard", icon: WSIcons.Home, path: "/dashboard" },
    { id: 2, label: "Loan Requests", icon: WSIcons.Document, path: "/loan/requests/list" },
    { id: 6, label: "Repayments", icon: WSIcons.Loan, path: "/loan/repayment/requests/list/filter" },
    { id: 7, label: "Finalized Loans", icon: WSIcons.Completed, path: "/loan/requests/final/list" },
    { id: 5, label: "Manage CDS", icon: WSIcons.People, path: "/manage/cds" },
    { id: 10, label: "Reports", icon: WSIcons.Report, path: "/reports" },
    { id: 4, label: "All Users", icon: WSIcons.LockIcon, path: "/users/list" },
    // { id: 9, label: "Notifications", icon: WSIcons.NotificationsNone, path: "/notifications" },
    // { id: 9, label: "Upload Loans", icon: WSIcons.Upload, path: "/upload/loans" },
    { id: 8, label: "About", icon: WSIcons.InfoIcon, path: "/aboutus" },
  ];

  const cdsMenu = [
    // { id: 1, label: "Dashboard", icon: WSIcons.Home, path: "/dashboard" },
    { id: 3, label: "My Applications", icon: WSIcons.Document, path: "/my-applications" },
    { id: 5, label: "Finalized Loans", icon: WSIcons.Completed, path: "/loan/requests/final/list" },
    { id: 2, label: "Reports", icon: WSIcons.Report, path: "/reports" },
    { id: 6, label: "About", icon: WSIcons.InfoIcon, path: "/aboutus" },
  ];

  switch (userType) {
    case "admin":
      return { staticMenu: adminMenu };
    case "district":
      return { staticMenu: districtMenu };
    case "block":
      return { staticMenu: blockMenu };
    case "cds":
      return { staticMenu: cdsMenu };
    default:
      return { staticMenu: [] };
  }
};

